/* ------------------------------------------------

    -- スクロールに合わせて位置移動させるものはここ

------------------------------------------------ */
export default class Fixed{
    constructor(){
        this.$target;
        this.start = true;/* trueで処理が開始される */
        this.point = [];
        this.num = 0;


        this.prevDir = "";/* scrollManagerから引き継いだ方向を保存する */

        /*  ステータスをセット */
        this.status = [];

        this.time=0;

    }
    init(winH,display){
        this.$target = document.querySelectorAll('.js__fsc');
        this.num = this.$target.length;

        this.start = (this.$target[0])?true:false;


        for(var i in this.$target){
            if(this.$target[i].nodeType!=1) break; // dom要素以外は処理止める
            var $t = this.$target[i];

            this.status[i] = {
                rate : $t.getAttribute('data-rate'),
                type : "",
                id : $t.getAttribute("data-id")
            }

            let _t;
            for(let j=0; j < $t.classList.length; j++){
                if($t.classList[j].match(/js__dir-/g))  _t = $t.classList[j].replace("js__","");
                this.status[i].type = _t;
            }
        }

        this.resize(winH,display)

    }
    animation(type,filterID){

        let _inc = 0;
        let _display = "";
        if(type=="out"){
            _inc = window.innerHeight;
            _display = "none"

            // console.log(this.num)

            let i = 0
            while( i < this.num){

                var $t = this.$target[i];

                if(filterID!=="") if(filterID===this.status[i].id) return;

                function comp() {
                    TweenLite.to($t.querySelectorAll("img"),0.1,{
                        display:_display,
                        delay:0.3
                    })
                }

                switch (this.status[i].type){
                    case "dir-y":
                        TweenLite.to($t,0.3,{
                            "y":-_inc,
                            onComplete:comp()
                        });
                        break;
                    case "dir-y-plus":
                        TweenLite.to($t,0.3,{
                            "y":_inc,
                            onComplete:comp()
                        });
                        break;
                    case "dir-x-plus":
                        TweenLite.to($t,0.5,{
                            "x":_inc*4,
                            onComplete:comp()
                        });
                        break;
                    case "dir-xy-minus":
                        TweenLite.to($t,0.3,{
                            "x":-_inc,
                            "y":-_inc,
                            onComplete:comp()
                            //delay:0.1
                        });
                        break;
                    case "dir-xy-plus":
                        TweenLite.to($t,0.3,{
                            "x":_inc,
                            "y":_inc,
                            onComplete:comp()
                            //delay:0.1
                        });
                        break;
                    case "dir-x-plus-y-minus":
                        TweenLite.to($t,0.3,{
                            "x":_inc,
                            "y":-_inc,
                            delay:0.2,
                            onComplete:comp()
                        });
                        break;
                    case "dir-x-minus-y-plus":
                        TweenLite.to($t,0.3,{
                            "x":-_inc,
                            "y":_inc,
                            delay:0.2,
                            onComplete:comp()
                        });
                        break;
                }
                i += 1

            }

        }else{
            _inc = 0;
            _display = "block"
            TweenLite.to(this.$target,0.3,{
                "x":0,
                "y":0,
                start:()=>{
                    let i = 0
                    while( i < this.num){
                        var $t = this.$target[i];
                        TweenLite.set($t.querySelectorAll("img"),{
                            display:_display,
                        })
                        i += 1

                    }
                }
            });
        }


    }

    resize (winH,display) {

        this.point = [];
        for (var i = 0; i < this.num; i++) {

            let $t = this.$target[i],
                rect =  $t.getBoundingClientRect();

            this.point[i] = {
                base  : rect.top,
                // start : $t.rect.top - winH,
                // end   : $t.rect.top + winH,
                start : (display=="pc")?rect.top - winH:rect.top - winH*2,
                end   : (display=="pc")?rect.top + winH:rect.top + winH/2,
            }

        }

        // console.log(this.point);

    }


}